module.exports = __webpack_public_path__ + "static/trainer2-cbda9bff85ef794d820e5d8ab95a9b27.png";